import { RolesRouteConfig } from '@emfood/shared/src/providers/auth/guard/index-route-guard';

// TODO: Move to shared
export const ROLES = {
  ADMIN: 'Full Access Admin',
  ENTEGRA_USER: 'Entegra User',
  ENTEGRA_PRICE_ADMIN: 'Entegra Price Admin',
  DISTRIBUTOR_ADMIN: 'Distributor Admin',
  SUPPLIER_ADMIN: 'Distributor Admin',
  PRODUCER_ADMIN: 'Producer Admin',
  CHEF: 'Chef',
  BUYER_ADMIN: 'Buyer Admin',
  CATERING_MANAGER: 'Catering Manager',
  CHARITY_BUYER: 'Charity Buyer',
  ANALYTICS: 'Analytics',
  DATA_MANAGER: 'Data Manager',
} as const;

export const PERMISSIONS = {
  USERS_READ: 'users:read',
  USERS_WRITE: 'users:write',
  USERS_INVITE: 'users:invite',
  USERS_REACTIVATE: 'users:reactivate',
  USERS_CREATE_ORDER_ISSUE_REPLY: 'users:create-order-issue-reply',
  // Products
  PRODUCTS_READ: 'products:read',
  PRODUCTS_WRITE: 'products:write',
  PRODUCT_PRICES_READ: 'product-prices:read',
  PRODUCT_PRICES_WRITE: 'product-prices:write',
  PRODUCT_STOCKS_READ: 'product-stocks:read',
  PRODUCT_STOCKS_WRITE: 'product-stocks:write',
  PRODUCTS_EXPORT: 'products:export',
  PRODUCTS_QUEUE_CATEGORY_ASSIGNMENT: 'products:queue-category-assignment',
  // General
  GENERAL: 'general',
  // Files
  FILES_WRITE: 'files:write',
  // Buyer Orgs
  BUYER_ORGS_READ: 'buyer-orgs:read',
  BUYER_ORGS_WRITE: 'buyer-orgs:write',
  BUYER_ORGS_READ_ORDERS: 'buyer-orgs:read-orders',
  BUYER_ORGS_READ_LINKED_DISTRIBUTOR_SITES: 'buyer-orgs:read-linked-distributor-sites',
  BUYER_ORGS_WRITE_OWN: 'buyer-orgs:write-own',
  BUYER_ORGS_READ_OWN: 'buyer-orgs:read-own',
  BUYER_ORGS_READ_ORDER_ISSUES: 'buyer-orgs:read-order-issues',
  BUYER_ORGS_REPLY_ORDER_ISSUES: 'buyer-orgs:reply-order-issues',
  // Buyer Sites
  BUYER_SITES_READ: 'buyer-sites:read',
  BUYER_SITES_WRITE: 'buyer-sites:write',
  BUYER_SITES_READ_SEASONS: 'buyer-sites:read-seasons',
  BUYER_SITES_READ_LINKED_SITES: 'buyer-sites:read-linked-sites',
  BUYER_SITES_READ_PRODUCERS: 'buyer-sites:read-producers',
  // Producers
  PRODUCERS_READ_OWN_PRODUCER_DETAILS: 'producers:read-own-producer-details',
  PRODUCERS_READ: 'producers:read',
  PRODUCERS_WRITE: 'producers:write',
  PRODUCERS_READ_MARKERS: 'producers:read-markers',
  PRODUCERS_READ_MEASUREMENTS: 'producers:read-measurements',
  PRODUCERS_WRITE_MEASUREMENTS: 'producers:write-measurements',
  PRODUCERS_WRITE_OWN: 'producers:write-own',
  PRODUCERS_READ_PRODUCT_TEMPLATES: 'producers:read-product-templates',
  // Distributors
  DISTRIBUTORS_LIST_ADMIN: 'distributors:list-admin',
  DISTRIBUTORS_CREATE: 'distributors:create',
  DISTRIBUTORS_READ: 'distributors:read',
  DISTRIBUTORS_WRITE: 'distributors:write',
  DISTRIBUTOR_SITES_READ: 'distributor-sites:read',
  DISTRIBUTOR_SITES_WRITE: 'distributor-sites:write',
  DISTRIBUTORS_READ_BUYER_ORDERS: 'distributors:read-buyer-orders',
  DISTRIBUTOR_SITES_WRITE_CATALOGUE: 'distributor-sites:write-catalogue',
  DISTRIBUTOR_SITES_SEARCH_PRODUCTS: 'distributor-sites:search-products',
  DISTRIBUTORS_CREATE_PRODUCT: 'distributors:create-product',
  DISTRIBUTORS_BULK_IMPORT_PRODUCTS: 'distributors:bulk-import-products',
  DISTRIBUTORS_READ_CSV_TEMPLATE_IMPORTS: 'distributors:read-csv-template-imports',
  DISTRIBUTORS_SEARCH_PRODUCTS: 'distributors:search-products',
  DISTRIBUTORS_BULK_IMPORT_CUSTOM_PRODUCT_PRICES: 'distributors:bulk-import-custom-product-prices',
  // Surplus
  DISTRIBUTOR_WRITE_SURPLUS: 'distributor:write-surplus',
  DISTRIBUTOR_WRITE_PROMOTION: 'distributor:write-promotion',
  DISTRIBUTOR_READ_SURPLUS: 'distributor:read-surplus',
  DISTRIBUTOR_READ_PROMOTION: 'distributor:read-promotion',
  // Prices
  DISTRIBUTORS_BULK_IMPORT_PRODUCT_PRICES: 'distributors:bulk-import-product-prices',
  DISTRIBUTORS_READ_CSV_PRICE_IMPORTS: 'distributors:read-csv-price-imports',
  DISTRIBUTORS_BULK_IMPORT_BESPOKE_PRODUCT_PRICES:
    'distributors:bulk-import-bespoke-product-prices',
  DISTRIBUTORS_READ_CSV_BESPOKE_PRICE_IMPORTS: 'distributors:read-csv-bespoke-price-imports',
  PRICES_EXPORT: 'prices:export',
  PRICES_EXPORT_CUSTOM: 'prices:export-custom',
  //
  DISTRIBUTOR_SITES_READ_BUYER_ORDERS: 'distributor-sites:read-buyer-orders',
  ORDERS_EXPORT_PO: 'orders:export-po',
  ORDERS_EXPORT_GRN: 'orders:export-grn',
  ORDERS_EXPORT_CNR: 'orders:export-cnr',
  DISTRIBUTORS_READ_LINKED_SITES: 'distributors:read-linked-sites',
  DISTRIBUTORS_READ_ORDER_ISSUES: 'distributors:read-order-issues',
  DISTRIBUTORS_REPLY_ORDER_ISSUES: 'distributors:reply-order-issues',
  // Distributor site linking
  DISTRIBUTOR_SITE_LINK_TO_BUYER: 'distributor-site:link-to-buyer',
  // Supplier aliases (same backend permissions as distributors)
  SUPPLIERS_LIST_ADMIN: 'distributors:list-admin',
  SUPPLIERS_CREATE: 'distributors:create',
  SUPPLIERS_WRITE: 'distributors:write',
  SUPPLIER_SITES_WRITE: 'distributor-sites:write',
  SUPPLIERS_BULK_IMPORT_PRODUCTS: 'distributors:bulk-import-products',
  SUPPLIERS_BULK_IMPORT_PRODUCT_PRICES: 'distributors:bulk-import-product-prices',
  SUPPLIERS_BULK_IMPORT_BESPOKE_PRODUCT_PRICES: 'distributors:bulk-import-bespoke-product-prices',
  SUPPLIER_SITE_LINK_TO_BUYER: 'distributor-site:link-to-buyer',
  // Distributor seasons
  DISTRIBUTORS_READ_SEASONS: 'distributors:read-seasons',
  DISTRIBUTORS_READ_SEASONS_ADMIN: 'distributors:read-seasons-admin',
  DISTRIBUTORS_WRITE_SEASONS: 'distributors:write-seasons',
  // Orders
  ORDERS_READ_ALL: 'orders:read-all',
  ORDERS_READ: 'orders:read',
  ORDERS_WRITE_ISSUES: 'orders:write-issues',
  ORDERS_READ_ISSUES: 'orders:read-issues',
  ORDERS_EXPORT_USER_PO: 'orders:export-user-po',
  ORDERS_EXPORT_USER_GRN: 'orders:export-user-grn',
  ORDERS_EXPORT_USER_CNR: 'orders:export-user-cnr',
  ORDERS_ADD_WEIGHT_RECEIVED: 'orders:add-weight-recieved',
  // Measuring methods
  MEASURING_METHODS_READ: 'measuring-methods:read',
  MEASURING_METHODS_WRITE: 'measuring-methods:write',
  MEASURING_METHOD_REQUESTS_WRITE: 'measuring-method-requests:write',
  MEASURING_METHOD_REQUESTS_READ: 'measuring-method-requests:read',
  // Measurements
  MEASUREMENTS_READ: 'measurements:read',
  MEASUREMENTS_DELETE: 'measurements:delete',
  MEASUREMENTS_RESOLVE: 'measurements:resolve',
  // Markers
  MARKERS_READ: 'markers:read',
  MARKERS_WRITE: 'markers:write',
  MARKER_INSTANCE_WRITE: 'marker-instance:write',
  // News
  NEWS_READ: 'news:read',
  NEWS_WRITE: 'news:write',
  // Cart
  CART: 'cart',
  // Favourites
  FAVOURITES_READ: 'favourites:read',
  FAVOURITES_WRITE: 'favourites:write',
  FAVOURITES_SHARE: 'favourites:share',
  // Shoppers
  BROWSE_PRODUCTS: 'browse-products',
  // Stories
  STORIES_GENERATE: 'stories:generate',
  STORIES_READ: 'stories:read',
  // Invoices
  INVOICES_READ: 'invoices:read',
  INVOICES_WRITE: 'invoices:write',
  // Invoice sender whitelist
  INVOICE_WHITELIST_READ: 'invoice-whitelist:read',
  INVOICE_WHITELIST_WRITE: 'invoice-whitelist:write',
};

export const ROLE_RESTRICTIONS: Record<
  string,
  { isOrgRestricted: boolean; isSiteRestricted: boolean }
> = {
  [ROLES.ADMIN]: { isOrgRestricted: false, isSiteRestricted: false },
  [ROLES.ENTEGRA_USER]: { isOrgRestricted: false, isSiteRestricted: false },
  [ROLES.ENTEGRA_PRICE_ADMIN]: { isOrgRestricted: false, isSiteRestricted: false },
  [ROLES.DISTRIBUTOR_ADMIN]: { isOrgRestricted: true, isSiteRestricted: false },
  [ROLES.PRODUCER_ADMIN]: { isOrgRestricted: true, isSiteRestricted: false },
  [ROLES.CHEF]: { isOrgRestricted: true, isSiteRestricted: true },
  [ROLES.BUYER_ADMIN]: { isOrgRestricted: true, isSiteRestricted: false },
  [ROLES.CATERING_MANAGER]: { isOrgRestricted: true, isSiteRestricted: false },
  [ROLES.CHARITY_BUYER]: { isOrgRestricted: true, isSiteRestricted: true },
  [ROLES.ANALYTICS]: { isOrgRestricted: true, isSiteRestricted: false },
  [ROLES.DATA_MANAGER]: { isOrgRestricted: true, isSiteRestricted: false },
} as const;

export const ALLOWED_ROLES = [
  ROLES.ADMIN,
  ROLES.ENTEGRA_USER,
  ROLES.ENTEGRA_PRICE_ADMIN,
  ROLES.DISTRIBUTOR_ADMIN,
  ROLES.PRODUCER_ADMIN,
  ROLES.CATERING_MANAGER,
  ROLES.ANALYTICS,
  ROLES.DATA_MANAGER,
  ROLES.BUYER_ADMIN,
] as const;

export const rolesIndexRouteConfig: RolesRouteConfig = {
  roleResolvers: [
    // Higher priority roles first
    {
      roleName: ROLES.ADMIN,
      resolver: () => ({
        path: '/user-managment',
      }),
    },
    {
      roleName: ROLES.ENTEGRA_USER,
      resolver: () => ({
        path: '/reporting',
      }),
    },
    {
      roleName: ROLES.ENTEGRA_PRICE_ADMIN,
      resolver: () => ({
        path: '/suppliers',
      }),
    },
    {
      roleName: ROLES.DISTRIBUTOR_ADMIN,
      resolver: (user) => {
        if (user.distributorOrg?.id) {
          return {
            path: '/suppliers/$supplierOrgId',
            params: { supplierOrgId: user.distributorOrg.id },
          };
        }
        return { path: '/user' };
      },
    },
    {
      roleName: ROLES.PRODUCER_ADMIN,
      resolver: (user) => {
        if (user.distributorOrg?.id) {
          return {
            path: '/suppliers/$supplierOrgId',
            params: { supplierOrgId: user.distributorOrg.id },
          };
        }
        return { path: '/user' };
      },
    },
    {
      roleName: ROLES.ANALYTICS,
      resolver: () => ({
        path: '/invoices',
      }),
    },
    {
      roleName: ROLES.DATA_MANAGER,
      resolver: (user) => {
        if (user.distributorOrg?.id) {
          return {
            path: '/suppliers/$supplierOrgId',
            params: { supplierOrgId: user.distributorOrg.id },
          };
        }
        return { path: '/user' };
      },
    },
    {
      roleName: ROLES.BUYER_ADMIN,
      resolver: (user) => {
        if (user.buyerOrg?.id) {
          return {
            path: '/buyers/$id',
            params: { id: user.buyerOrg.id },
          };
        }
        return { path: '/buyer-orders' };
      },
    },
  ],
  fallbackRoute: '/user',
};
